import Vue from "vue";
import * as VueGoogleMaps from 'vue2-google-maps';
import { BootstrapVue } from "bootstrap-vue";
import vSelect from "vue-select";
import VueCompositionAPI from "@vue/composition-api";
import VueObserveVisibility from "vue-observe-visibility";

import router from "./router";
import store from "./store";
import App from "./App.vue";
import "@/plugins/vee-validate";
// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";
import "@/libs/sweet-alerts";

// BSV Registration
Vue.use(BootstrapVue);

// Composition API
Vue.use(VueCompositionAPI);

//VueSelect
Vue.component("v-select", vSelect);

Vue.use(VueObserveVisibility);

Vue.use(require("vue-moment"));

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAXVVZ5v2Uu5OmIEEF2JVDOZjcAQtj5WDw',
    libraries: 'places', // if you need to use places input
  },
});

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

require("vue-select/dist/vue-select.css");

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

require("@core/scss/vue/pages/page-auth.scss");
require("@core/scss/vue/libs/vue-wizard.scss");
require("@core/scss/vue/libs/vue-select.scss");

Vue.config.productionTip = false;

function checkAuth() {
  return new Promise(async (resolve) => {
    try {
      await store.dispatch("appData/getCurrentUser");
      resolve();
    } catch (error) {
      resolve();
    }
  });
}

function createApp() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

function createBeforeEach() {
  router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (store.getters["appData/isLoggedIn"]) {
        // Check if user has active subscription or is a superuser
        const currentUser = store.getters["appData/getLoggedInUser"];
        const hasActiveSubscription = currentUser && currentUser.is_active_subscription;
        const isSuperuser = currentUser && currentUser.is_superuser;

        // If trying to access any page except subscription page without active subscription (and not superuser), redirect to subscription
        if (!hasActiveSubscription && !isSuperuser && to.name !== "PublicSubscription") {
          next({ name: "PublicSubscription" });
          return;
        }

        // If trying to access subscription page but already has active subscription or is superuser, redirect to dashboard
        if ((hasActiveSubscription || isSuperuser) && to.name === "PublicSubscription") {
          next({ name: "Dashboard" });
          return;
        }
        
        if (to.meta.permission) {
          if (store.getters["appData/hasPermission"](to.meta.permission)) {
            next();
          } else {
            next({ name: "Dashboard" });
          }
        } else {
          next();
        }
      } else {
        next({ name: "Login" });
      }
    } else {
      next();
    }
  });
}

checkAuth().then(() => {
  createBeforeEach();
  createApp();
});
